<template>
  <div class="scroll-control">
    <el-button
      type="primary"
      icon="el-icon-arrow-up"
      @click="handleScroll('top')"
      style="margin-bottom: 8px"
      >顶部</el-button
    >
    <el-button
      type="primary"
      @click="handleScroll('bottom')"
    >
      底部 <i class="el-icon-arrow-down"></i>
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    tableRef: {
      type: Object,
      required: true,
      default: () => {},
    },
    controlParent: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleScroll(type) {
      this.$scrollTable(this.tableRef, type, this.controlParent);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.scroll-control {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  right: 0;
  bottom: 30px;
  z-index: 2000;
}
.scroll-control /deep/ .el-button {
  width: 36px !important;
  min-width: 36px !important;
  height: auto;
  padding: 10px 0 !important;
  writing-mode: vertical-rl !important;
}
.scroll-control /deep/ .el-button + .el-button {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ScrollControl/index.vue